import { NavMessage } from "../messages/NavMessage";
import { NavigationExtentContext } from "./NavigationContext";
import { InspectionsLayer } from "../layers/selectable/InspectionsLayer";
import { Switchboard } from "../../lib/events";
import { Maybe } from "../../lib/misc/option";
import { SalesRatioLayer } from "../layers/selectable/SalesRatioLayer";
export class SetContext extends NavigationExtentContext {
    constructor(map, p_layer) {
        super(p_layer, map);
        this.zoomed = false;
        this.result_set_features = [];
        this.broadcaster = Switchboard.get_emitter("CONTEXT");
        this.name = 'set';
        this.exit_contexts = ['singleton', 'selection', 'group', 'toolbar'];
    }
    on_enter() {
        this.result_set_features = [];
        this.result_set_features = this.layer.features.map(f => this.layer.data.id_of(f));
    }
    on_exit() { this.zoomed = false; }
    async click_handler(coord, alt) {
        const features = this.layer.features.map(f => this.layer.data.id_of(f));
        const removeables = features.filter(id => !this.result_set_features.includes(id));
        await this.layer.remove_features_by_ids([...removeables]);
        const intersected_features = this.layer.features.filter(f => {
            const geo = Maybe(f.getGeometry());
            return geo.map(g => g.intersectsCoordinate(coord)).unwrapOr(false);
        });
        if (intersected_features.length > 0) {
            const id = this.layer.data.id_of(intersected_features[0]);
            await this.layer.select_feature(id);
            if (id)
                new NavMessage({ command: 'NAVIGATE', strap: id, clicked: true, alt: alt }).send();
            return;
        }
        await this.layer.add_feature_at_point(coord, alt);
        const id = this.layer.clicked;
        if (id)
            new NavMessage({ command: 'NAVIGATE', strap: id, clicked: true, alt: alt }).send();
        if (this.layer instanceof InspectionsLayer || this.layer instanceof SalesRatioLayer)
            return;
    }
    async zoom(force) {
        if (force || !this.zoomed) {
            super.zoom(force);
            this.zoomed = true;
        }
        await this.map.load_startup_visible_layers();
    }
    navigate(strap) {
        new NavMessage({ command: 'NAVIGATE', strap: strap, clicked: false, alt: false }).send();
    }
}
